import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { ScriptLoaderProvider } from './contexts/ScriptLoaderContext';
import ErrorBoundary from './components/ErrorBoundary';
import Onboarding from './components/Onboarding';
import CourseList from './components/CourseList';
import CourseDetail from './components/CourseDetail';
import CourseTemplate from './components/CourseTemplate';
import CourseValidatorComponent from './components/CourseValidator';

function App() {
    // 사용자 정보 확인
    const checkUserInfo = () => {
        const userInfo = localStorage.getItem('userInfo');
        if (!userInfo) return false;
        
        try {
            const info = JSON.parse(userInfo);
            // 필수 정보가 모두 있는지 확인
            return info.nickname && info.interests && info.theme;
        } catch {
            return false;
        }
    };

    return (
        <ErrorBoundary>
            <LanguageProvider>
                <ScriptLoaderProvider>
                    <ThemeProvider>
                        <Router>
                            <Routes>
                    {/* 루트 경로 */}
                    <Route
                        path="/"
                        element={
                            checkUserInfo() ?
                                <Navigate to="/courses" replace /> :
                                <Navigate to="/onboarding" replace />
                        }
                    />

                    {/* 온보딩 */}
                    <Route path="/onboarding" element={<Onboarding />} />

                    {/* 코스 목록 */}
                    <Route path="/courses" element={<CourseList />} />

                    {/* 코스 상세 */}
                    <Route path="/courses/:courseId" element={<CourseDetail />} />

                    {/* 코스 학습 */}
                    <Route path="/courses/:courseId/step/:stepId" element={<CourseTemplate />} />

                    {/* 코스 검증기 (개발용) */}
                    <Route path="/validator" element={<CourseValidatorComponent />} />

                    {/* 404 */}
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </Router>
        </ThemeProvider>
        </ScriptLoaderProvider>
        </LanguageProvider>
        </ErrorBoundary>
    );
}

// 404 페이지 컴포넌트
const NotFound = () => {
    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            textAlign: 'center',
            padding: '20px'
        }}>
            <h1 style={{ fontSize: '4rem', marginBottom: '1rem' }}>404</h1>
            <p style={{ fontSize: '1.2rem', color: 'var(--text-secondary)', marginBottom: '2rem' }}>
                페이지를 찾을 수 없습니다
            </p>
            <a href="/courses" className="btn btn-primary">
                코스 목록으로 돌아가기
            </a>
        </div>
    );
};

export default App;